// global
import React from 'react';
import PropTypes from 'prop-types';
// components
import ChangeStatusButton from 'app/components/commons/button/ChangeStatusButton';
import EditButton from 'app/components/commons/button/EditButton';

//style
import styles from './PopupButton.module.scss';

function PopupButton(props) {
  const {
    entity,
    onClickEdit,
    onChangeStatus,
    pencil,
    isPadCreatorStyle,
    disalbedChangeStatus,
    disabledEdit,
    tagChangeStatusButton,
    tagEditButton
  } = props;

  return (
    <div className={styles.popupButton}>
      <EditButton
        entity={entity}
        pencil={pencil}
        onClickEdit={onClickEdit}
        disabled={disabledEdit}
        tag={tagEditButton}
      />
      <ChangeStatusButton
        entity={entity}
        onChangeStatus={onChangeStatus}
        disabled={disalbedChangeStatus}
        isPadCreatorStyle={isPadCreatorStyle}
        tag={tagChangeStatusButton}
      />
    </div>
  );
}

PopupButton.defaultProps = {
  disabledEdit: false,
  disalbedChangeStatus: false
};

PopupButton.propTypes = {
  entity: PropTypes.object,
  onClickEdit: PropTypes.func,
  onChangeStatus: PropTypes.func,
  isForm: PropTypes.bool,
  pencil: PropTypes.string,
  isPadCreatorStyle: PropTypes.bool,
  disalbedChangeStatus: PropTypes.bool,
  disabledEdit: PropTypes.bool,
  tagChangeStatusButton: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  tagEditButton: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};

export default PopupButton;
